document.addEventListener('turbolinks:load', function () {
    var copyButton = document.getElementById('copyLinkToPage');

    if (!copyButton) return

    copyButton.addEventListener('click', function () {
        var linkToCopy = this.getAttribute('data-link');
        navigator.clipboard.writeText(linkToCopy).then(function() {
            show_ajax_notice("Link copied to clipboard!");
        }, function(err) {
            window.rollbar.error('Could not copy text: ', err);
        });
    });
});
